import _defineProperty from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import styled from 'styled-components';
import { makeStyles } from '@mui/styles';
import Image from '../../../atoms/Image';
import { deviceSizes } from '../../../../config/devices';
import Link from '../../../atoms/Link';
export var FooterContainer = styled.div.withConfig({
  displayName: "style__FooterContainer",
  componentId: "sc-1ps727-0"
})(["background-color:", ";width:100%;padding:3rem 1rem;color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.secondaryColor[800];
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.secondary.contrastText;
});
export var FooterColumn = styled.div.withConfig({
  displayName: "style__FooterColumn",
  componentId: "sc-1ps727-1"
})(["display:flex;flex-direction:column;padding:0 0.5rem;p{font-size:0.8rem;color:", ";}li{list-style:none;p{color:", ";transition:250ms color;cursor:pointer;font-size:1rem;&:hover{color:", ";}}}@media (max-width:", "){margin-top:2rem;}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.grey[200];
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.grey[200];
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.white;
}, deviceSizes.tablet);
export var Logo = styled(Image).withConfig({
  displayName: "style__Logo",
  componentId: "sc-1ps727-2"
})(["margin-bottom:", ";"], function (_ref6) {
  var bottom = _ref6.bottom;
  return bottom || '1rem';
});
export var FooterRow = styled.div.withConfig({
  displayName: "style__FooterRow",
  componentId: "sc-1ps727-3"
})(["display:flex;flex-direction:row;justify-content:space-between;"]);
export var ColumnHeader = styled.div.withConfig({
  displayName: "style__ColumnHeader",
  componentId: "sc-1ps727-4"
})(["line-height:2rem;padding:0 1rem 0 0;h5{color:", ";}"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.white;
});
export var SocialList = styled.ul.withConfig({
  displayName: "style__SocialList",
  componentId: "sc-1ps727-5"
})(["padding:0.2rem;li{display:inline-block;margin-right:0.9rem;& a{margin:0;}}svg{fill:white;}"]);
export var ColumnContent = styled.div.withConfig({
  displayName: "style__ColumnContent",
  componentId: "sc-1ps727-6"
})(["margin:30px 0;display:flex;flex-direction:column;ul{padding:0;margin:0;}a{padding-right:1rem;width:100%;text-decoration:none;}"]);
export var useClasses = makeStyles({
  Search: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '25px',
      backgroundColor: '#616161',
      color: 'white',
      '&:hover fieldset': {
        borderColor: '#757575'
      },
      '&.Mui-focused fieldset': {
        borderColor: '#757575'
      },
      '& svg': {
        fill: '#FFFFFF'
      }
    }
  },
  Quicklinks: _defineProperty({
    display: 'flex',
    justifyContent: 'center'
  }, "@media(max-width: ".concat(deviceSizes.sm, ")"), {
    justifyContent: 'flex-start'
  }),
  BoxWithJMLogo: _defineProperty({
    display: 'flex',
    justifyContent: 'space-between'
  }, "@media(max-width: ".concat(deviceSizes.sm, ")"), {
    flexDirection: 'column'
  }),
  MainContainer: _defineProperty({
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'flex-start'
  }, "@media(max-width: ".concat(deviceSizes.md, ")"), {
    justifyContent: 'flex-start'
  })
});